export const environment = {
  production: true,
  noindex: true,
  apiBaseUrl: 'https://paystation-api.itax.in.th',
  jobBaseUrl: 'https://jobapplication-api.itax.in.th',
  jobFrontBaseUrl: 'https://debut.itax.in.th',
  multiplePayment: false,
  dashboard: true,
  alwaysAutoCalPayroll: false,
};
